import { AfterViewInit, Component, ElementRef, HostListener, inject } from '@angular/core';
import { NgClass, NgTemplateOutlet } from '@angular/common';

import { SsrService } from '@services/ssr.service';
import { GlobalAnimations } from '@core/animations';

@Component({
  selector: 'app-car-detail-header',
  imports: [NgClass, NgTemplateOutlet],
  templateUrl: './car-detail-header.component.html',
  styleUrls: ['./car-detail-header.component.scss'],
  animations: [GlobalAnimations.slideFromTop],
})
export class CarDetailHeaderComponent implements AfterViewInit {
  private el = inject(ElementRef);
  private ssrService = inject(SsrService);
  public isSticky: boolean = false;

  @HostListener('window:scroll') onScroll(): void {
    this.checkIfSticky();
  }

  @HostListener('window:resize') onResize(): void {
    this.checkIfSticky();
  }

  checkIfSticky(): void {
    if (this.ssrService.isServer()) return;
    const carDetailMain = document.querySelector('.car-detail__main');
    const rectTop = carDetailMain?.getBoundingClientRect().top || 0;
    const headerHeight = this.el.nativeElement.querySelector('.car-detail__header');
    this.isSticky = rectTop - (headerHeight?.clientHeight || 0) - 32 <= 0;
  }

  ngAfterViewInit(): void {
    if (this.ssrService.isServer()) return;
    setTimeout(() => {
      this.checkIfSticky();
    }, 1);
  }
}
